export const mockSessionTypesListResponse = {
  rescode: 1,
  message: "Session types fetched successfully",
  data: [
    // One-Time
    {
      id: 1, clinic_id: 1, title: "Evaluation", recurrence_mode: "single",
      billing_cycle: "daily", max_days_selection: 1, is_active: 1, sort_order: 1,
      days: [], patient_count: 5,
    },
    {
      id: 2, clinic_id: 1, title: "Trial Session", recurrence_mode: "single",
      billing_cycle: "daily", max_days_selection: 1, is_active: 1, sort_order: 2,
      days: [], patient_count: 8,
    },
    {
      id: 3, clinic_id: 1, title: "Follow-Up", recurrence_mode: "single",
      billing_cycle: "daily", max_days_selection: 1, is_active: 1, sort_order: 3,
      days: [], patient_count: 12,
    },
    {
      id: 4, clinic_id: 1, title: "Re-Evaluation", recurrence_mode: "single",
      billing_cycle: "daily", max_days_selection: 1, is_active: 1, sort_order: 4,
      days: [], patient_count: 3,
    },
    // Recurring
    {
      id: 5, clinic_id: 1, title: "Regular Therapy", recurrence_mode: "weekly",
      billing_cycle: "monthly", max_days_selection: 6, is_active: 1, sort_order: 5,
      days: [
        { id: 1, day_of_week: 1 }, { id: 2, day_of_week: 2 },
        { id: 3, day_of_week: 3 }, { id: 4, day_of_week: 4 },
        { id: 5, day_of_week: 5 }, { id: 6, day_of_week: 6 },
      ],
      patient_count: 42,
    },
    // Packages
    {
      id: 6, clinic_id: 1, title: "2 Day Package", recurrence_mode: "preset",
      billing_cycle: "monthly", max_days_selection: 2, total_sessions: 8,
      is_active: 1, sort_order: 6,
      days: [{ id: 7, day_of_week: 1 }, { id: 8, day_of_week: 4 }],
      patient_count: 6,
    },
    {
      id: 7, clinic_id: 1, title: "3 Day Package", recurrence_mode: "preset",
      billing_cycle: "monthly", max_days_selection: 3, total_sessions: 12,
      is_active: 1, sort_order: 7,
      days: [
        { id: 9, day_of_week: 1 }, { id: 10, day_of_week: 3 },
        { id: 11, day_of_week: 5 },
      ],
      patient_count: 18,
    },
    {
      id: 8, clinic_id: 1, title: "4 Day Package", recurrence_mode: "preset",
      billing_cycle: "monthly", max_days_selection: 4, total_sessions: 16,
      is_active: 1, sort_order: 8,
      days: [
        { id: 12, day_of_week: 1 }, { id: 13, day_of_week: 3 },
        { id: 14, day_of_week: 5 }, { id: 15, day_of_week: 6 },
      ],
      patient_count: 14,
    },
    {
      id: 9, clinic_id: 1, title: "5 Day Package", recurrence_mode: "preset",
      billing_cycle: "monthly", max_days_selection: 5, total_sessions: 20,
      is_active: 1, sort_order: 9,
      days: [
        { id: 16, day_of_week: 1 }, { id: 17, day_of_week: 2 },
        { id: 18, day_of_week: 3 }, { id: 19, day_of_week: 4 },
        { id: 20, day_of_week: 5 },
      ],
      patient_count: 10,
    },
    {
      id: 10, clinic_id: 1, title: "Intensive Program", recurrence_mode: "preset",
      billing_cycle: "monthly", max_days_selection: 6, total_sessions: 24,
      is_active: 1, sort_order: 10,
      days: [
        { id: 21, day_of_week: 1 }, { id: 22, day_of_week: 2 },
        { id: 23, day_of_week: 3 }, { id: 24, day_of_week: 4 },
        { id: 25, day_of_week: 5 }, { id: 26, day_of_week: 6 },
      ],
      patient_count: 4,
    },
    // Special
    {
      id: 11, clinic_id: 1, title: "Parent Training", recurrence_mode: "single",
      billing_cycle: "daily", max_days_selection: 1, is_active: 1, sort_order: 11,
      days: [], patient_count: 15,
    },
    {
      id: 12, clinic_id: 1, title: "Home Visit", recurrence_mode: "single",
      billing_cycle: "daily", max_days_selection: 1, is_active: 1, sort_order: 12,
      days: [], patient_count: 7,
    },
    {
      id: 13, clinic_id: 1, title: "Online Session", recurrence_mode: "single",
      billing_cycle: "daily", max_days_selection: 1, is_active: 1, sort_order: 13,
      days: [], patient_count: 9,
    },
    // Group
    {
      id: 14, clinic_id: 1, title: "Group Session", recurrence_mode: "preset",
      billing_cycle: "monthly", max_days_selection: 1, total_sessions: 4,
      is_active: 1, sort_order: 14,
      days: [{ id: 27, day_of_week: 6 }],
      patient_count: 22,
    },
  ],
};
